import React from 'react';
import ProteinVariantView from './ProteinVariantView';
import { RMModal } from 'components/modal';
import { FmlxModal } from 'fmlx-common-ui';

const ProteinVariant = (props) => {
  const {
    showModal,
    setShowModal,
    parentProteinTreeNodeId,
    setRefreshVariantList,
    refreshVariantList,
    proteinFormulationVariants,
  } = props;

  return (
    <RMModal
      id="index-protein-variant-modal"
      showModal={showModal}
      setShowModal={setShowModal}
      onHide={() => {
        setShowModal(false);
      }}
      dialogClassName="proteinVariant-Modal"
      body={
        <ProteinVariantView
          id='index-protein-variant-view'
          setShowModal={setShowModal}
          parentProteinTreeNodeId={parentProteinTreeNodeId}
          setRefreshVariantList={setRefreshVariantList}
          refreshVariantList={refreshVariantList}
          proteinFormulationVariants={proteinFormulationVariants}
        />
      }
      size={FmlxModal.Size.LARGE}
      showButtons={false}
      hideCloseButton={true}
    />
  );
};

export default ProteinVariant;
